import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Col, Row } from 'angieslist-react-components';
import { compose, pure } from 'recompose';
import getErrorMessage from 'angieslist-app-platform/lib/common/getErrorMessage';
import './advertiseClaimDiscount.scss';

export const AdvertiseClaimDiscountComponent = (props) => {
  const {
    advertiseRequest, advertiseRequestWasSuccessful, advertiseRequestError,
    advertiseRequestPending, closeAlert, activityLocation,
  } = props;


  return (
    <Row>
      <Col xs={12}>
        <If condition={advertiseRequestError}>
          <Alert bsStyle="danger" onDismiss={closeAlert}>
            {getErrorMessage(advertiseRequestError)}
          </Alert>
        </If>
        <If condition={advertiseRequestWasSuccessful}>
          <Alert bsStyle="success" onDismiss={closeAlert}>
              Thank you for your interest in advertising with Angi.
              A representative will contact you shortly.
          </Alert>
        </If>
        <div>
          <div id="office-home--advertise-claim-discount">
            <Row id="office-home--advertise-claim-discount-row" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>

              <Col xs={12} md={4}>
                <div id="office-home--advertise-claim-discount-banner">
                  <p>For a limited time get up to</p>
                  <h1>40% off</h1>
                </div>
              </Col>
              <Col xs={12} md={5}>
                <p id="discount-text">
                  Get additional exposure opportunities and gain access
                  to homeowners at our most discounted rates of the year.
                </p>
              </Col>
              <Col xs={12} md={3}>
                <Button
                  bsStyle="primary-office"
                  bsSize="small"
                  id="office-home--advertise-with-us--submit-request-button"
                  onClick={() => advertiseRequest(activityLocation, 'Promotional Banner')}
                  loading={advertiseRequestPending}
                  disabled={advertiseRequestPending}
                  block
                  flat
                >
                  Claim Discount
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  );
};

AdvertiseClaimDiscountComponent.propTypes = {
  advertiseRequest: PropTypes.func.isRequired,
  advertiseRequestWasSuccessful: PropTypes.bool,
  advertiseRequestError: PropTypes.bool,
  advertiseRequestPending: PropTypes.bool,
  closeAlert: PropTypes.func,
  activityLocation: PropTypes.string,
};

AdvertiseClaimDiscountComponent.defaultProps = {
  advertiseRequestWasSuccessful: false,
  advertiseRequestError: false,
  advertiseRequestPending: false,
};

export default compose(pure)(AdvertiseClaimDiscountComponent);



// WEBPACK FOOTER //
// ./src/app/browser/AdvertiseClaimDiscount.js